import {
  FormLabel,
  HelpCircleIcon,
  HStack,
  Tooltip,
  Spacer,
} from '@packages/systems/spring';
import React from 'react';
import {TokenSelect} from './tokenSelect';

type EmailNotificationFieldLabelProps = {
  htmlFor: string;
  text: string;
  helpText: string;
  tokens?: {label: string; value: string}[];
  onTokenClick?: (value: string) => void;
};

export const EmailNotificationFieldLabel = ({
  htmlFor,
  text,
  helpText,
  tokens,
  onTokenClick,
}: EmailNotificationFieldLabelProps) => (
  <HStack>
    <FormLabel htmlFor={htmlFor}>{text}</FormLabel>
    <Tooltip content={helpText}>
      <HelpCircleIcon />
    </Tooltip>
    <Spacer />
    {tokens && onTokenClick && (
      <TokenSelect tokens={tokens} onTokenClick={onTokenClick} />
    )}
  </HStack>
);
